module.exports = __webpack_public_path__ + "img/pasture_panicum_low.a50dd988.webp";